import styled, { Keyframes, keyframes } from 'styled-components';

export const StyledDrawer = styled.div`
  position: fixed;
  z-index: 1200;
  inset: 0px;
`;

type DrawerPosition = 'top' | 'bottom' | 'left' | 'right';

const positionVariants: {
  [key in 'bottom' | 'top' | 'left' | 'right']: {
    transformFrom: string;
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
  };
} = {
  bottom: {
    transformFrom: 'translateY(100%)',
    top: 'auto'
  },
  top: {
    transformFrom: 'translateY(-100%)',
    bottom: 'auto'
  },
  left: {
    transformFrom: 'translateX(-100%)',
    right: 'auto'
  },
  right: {
    transformFrom: 'translateX(100%)',
    left: 'auto'
  }
};

export const showIn = (position: DrawerPosition): Keyframes => keyframes`
  from {
    transform: ${positionVariants[position].transformFrom};
  } to {
    transform: translateY(0);
  }
`;

export const StyledBackdrop = styled.div<{ show: boolean }>`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  z-index: -1;
  position: fixed;
  align-items: center;
  justify-content: center;
  background-color: rgb(255 255 255 / 80%);
  -webkit-tap-highlight-color: transparent;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`;

export const StyledDrawerContainer = styled.div<{
  show: boolean;
  position: DrawerPosition;
  variant: 'temporary' | 'permanent';
}>`
  top: ${({ position }) => positionVariants[position].top || 0};
  left: ${({ position }) => positionVariants[position].left || 0};
  right: ${({ position }) => positionVariants[position].right || 0};
  bottom: ${({ position }) => positionVariants[position].bottom || 0};
  height: auto;
  max-height: 100%;
  flex: 1 0 auto;
  display: flex;
  outline: 0;
  position: ${({ variant }) => (variant === 'temporary' ? 'fixed' : 'static')};
  overflow-y: auto;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
  color: rgba(0, 0, 0, 0.87);
  background-color: #fff;
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  transform: ${({ show, position }) =>
    show ? 'translateY(0)' : positionVariants[position].transformFrom};
  animation: ${({ position }) => showIn(position)} 225ms
    cubic-bezier(0, 0, 0.2, 1);
`;
